/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import ProductDropDown from 'src/business-components/ProductDropDown';
import PropTypes from 'prop-types';
import { PRODUCT_CATEGORY_TYPES } from 'src/containers/product-container/ProductConstants';
import FormikDateTimePicker from 'src/components/formik/FormikDateTimePicker';
import FormikInput from 'src/components/formik/FormikInput';
import FormikToggle from 'src/components/formik/FormikToggle';
import { productSearchAPI } from 'src/api/ProductApi';
import { MASTERS_TYPES } from 'src/containers/masters-container/MastersConstants';
import MastersDropDown from 'src/business-components/MastersDropDown';
// import { formik } from 'formik';

function VehicleInsuranceCaseForm({ values, setFieldValue }) {

    const [cubicCapacity, setCubicCapacity] = useState('');

    const handleVehicleSelect = async (vechileId) => {
        const vechileDetails = await productSearchAPI({ where: { "_id": vechileId } })
        const cubicCapacity = vechileDetails?.data?.data?.data[0]?.meta?.cubicCapacity;
        setFieldValue("meta.cubicCapacity", cubicCapacity)
    };
    return (
        <div className="mt-3">
            <h3>
                Vehicle Information
            </h3>
            <div className="form-row">
                <div className="form-group col-md-3">
                    <label>Vehicle Name</label>
                    <ProductDropDown
                        name="meta.vehicleProductId"
                        value={values?.meta?.vehicleProductId || ''}
                        productCategory={PRODUCT_CATEGORY_TYPES.VEHICLE}
                        onChange={handleVehicleSelect}
                    />
                </div>
                <div className="form-group col-md-3">
                    <label>Cubic Capacity (C.C.)</label>
                    <FormikInput
                        name="meta.cubicCapacity"
                        type="text"
                        className="form-control"
                        value={values.meta.cubicCapacity}
                        disabled
                    />
                </div>
                {/* <div className="form-group col-md-3">
                    <label>Fuel Type</label>
                    <FormikInput
                        name="meta.fuelType"
                        type="text"
                        className="form-control"
                        value={values.meta.fuelType}
                        disabled
                    />
                </div> */}

                {/* <div className="form-group col-md-3">
                    <label>Policy Issue Date</label>
                    <FormikDateTimePicker
                        name="cn_date"
                        value={values?.cn_date || ''}
                        className="form-control"
                        disableClock
                        format="dd-MM-y"
                    />
                </div> */}

                <div className="form-group col-md-3">
                    <label>Model Year</label>
                    <FormikInput
                        name="meta.vehicleModelYear"
                        type="text"
                        className="form-control"
                    />
                </div>

                <div className="form-group col-md-3">
                    <label>Vehicle Number</label>
                    <FormikInput
                        name="meta.vehicleNumber"
                        type="text"
                        className="form-control"
                    />
                </div>

                <div className="form-group col-md-3">
                    <label>Engine Number</label>
                    <FormikInput
                        name="meta.engineNumber"
                        type="text"
                        className="form-control"
                    />
                </div>
                <div className="form-group col-md-3">
                    <label>Chasis Number</label>
                    <FormikInput
                        name="meta.chasisNumber"
                        type="text"
                        className="form-control"
                    />
                </div>
                <div className="form-group col-md-3">
                    <label>RTO State</label>
                    <MastersDropDown
                        name="rtoZone"
                        value={values?.rtoZone || ''}
                        masterType={MASTERS_TYPES.RTO_ZONE}
                    />
                </div>
                <div className="form-group col-md-3">
                        <label>NCB (%)</label>
                            <FormikInput
                                name="ncbPercentage"
                                type="text"
                                className="form-control"
                                value={values?.ncbPercentage}
                            />
                        </div>
                <div className="form-row">
                    <div className="form-group col">
                        <label className="col-md-12">Sold?</label>
                        <FormikToggle name="meta.isSold" value={values?.meta?.isSold || false} />
                    </div>
                </div>
            </div>
        </div>
    );
}

VehicleInsuranceCaseForm.propTypes = {
    values: PropTypes.shape({
        meta: PropTypes.shape({
            vehicleProductId: PropTypes.string,
            vehicleModelYear: PropTypes.string,
            vehicleNumber: PropTypes.string,
            policyDueDate: PropTypes.string,
        }),
        productCategory: PropTypes.string,
    }),
};

VehicleInsuranceCaseForm.defaultProps = {
    values: {
        meta: {
            vehicleProductId: '',
        },
        productCategory: '',
    },
};

export default VehicleInsuranceCaseForm;
